<template>
  <v-container>
    <v-layout row wrap align-top class="text-xs-center">
        <v-flex xs12 class="pa-2">

          <h2 class="display-1" style="text-decoration: underline;">Sign Up</h2>
        </v-flex>
        <v-flex>

          <!-- <v-btn color="white" to="/signup/mon">Signup Winter Monday</v-btn>
          <v-btn :disabled="false" color="white" to="/signup/wed">Signup Winter Wednesday</v-btn>
          <v-btn color="white" to="/signup/thur">Signup Winter Thursday</v-btn> -->

          <v-btn color="yellow" to="/signup/mon">Signup Summer Monday</v-btn>
          <!-- <v-btn :disabled="false" color="white" to="/signup/wed">Signup Winter Wednesday</v-btn> -->
          <v-btn color="yellow" to="/signup/thur">Signup Summer Thursday</v-btn>

          <v-btn color="primary" to="/signup/mon2">Signup Spring Monday</v-btn>
          <v-btn :disabled="false" color="primary" to="/signup/wed2">Signup Spring Wednesday</v-btn>
          <v-btn color="primary" to="/signup/thur2">Signup Spring Thursday</v-btn>
          <!-- <v-btn color="yellow" to="/camp"><v-icon>mdi-weather-sunny</v-icon>Signup Kick It Up Camp</v-btn> -->
          <!-- <v-btn color="Grey" to="/popup"><v-icon>mdi-snowflake</v-icon>Signup Winter Warrior Tournament</v-btn> -->
        </v-flex>
        <!-- <v-flex xs12 >
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfOywALsCmspC5Lgb9COHT-up4Lv4xmpAvFMgxdm5DdXfylxg/viewform" width="500" height="1600" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </v-flex> -->
        <v-flex xs12>
          <v-btn
            large
            color="primary"
            class="mx-0"
            to="/pay"

          >Go to Payments</v-btn>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    computed: {
      size () {
        const binding = {}
        if (this.$vuetify.breakpoint.xsOnly) binding.column = true
        return binding
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select {
appearance: menulist;
}
table {
    margin: auto;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/signup.vue